import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import * as Device from 'react-device-detect';

interface HeaderProps {
  handleBack: (e: React.SyntheticEvent, reason: string) => void;
  children?: React.ReactNode;
}

function Header(props: Readonly<HeaderProps>) {
  const { handleBack, children } = props;
  const theme = useTheme();
  const { t } = useTranslation('cta');

  return (
    <AppBar component="nav" position={Device.isMobileOnly ? 'fixed' : 'sticky'} elevation={0} sx={{ px: 0 }}>
      <Toolbar sx={{ justifyContent: 'space-between', width: '100%' }}>
        <Stack>{children}</Stack>
        <Button
          variant="outlined"
          color="uncolored"
          size="small"
          startIcon={<theme.icons.close />}
          onClick={handleBack}
        >
          {t('close')}
        </Button>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
